<template>
  <v-card outlined flat>
    <v-toolbar flat>
      <v-toolbar-title>
        <v-icon left>attachment</v-icon>
        <slot name="title">Attachments</slot>
      </v-toolbar-title>
    </v-toolbar>
    <v-list dense v-if="!loading">
      <template v-for="item in attachments">
        <v-list-item :key="item.id">
          <v-list-item-icon>
            <v-btn icon :href="item.upload">
              <v-icon>fas fa-paperclip</v-icon>
            </v-btn>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ item.uploaded_at }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <span class="d-inline-flex">
              <AttachmentFormEdit :instance="item" />
              <AttachmentFormDelete :instance="item" />
            </span>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="`divider-` + item.id" />
      </template>
    </v-list>
    <v-card-actions>
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
import AttachmentFormEdit from "./AttachmentFormEdit";
import AttachmentFormDelete from "./AttachmentFormDelete";
export default {
  name: "BaseAttachmentList",
  components: { AttachmentFormDelete, AttachmentFormEdit },
  props: {
    attachments: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true,
      default: true
    }
  }
};
</script>
